import { Packages_Action_Types } from "./packages.types"

const initialState = {
    packages: [],
    packagesListByType: [],
    isLoading: false,
    error: null,
    pagination: {
        pageNumber: 1,
        perPage: 10,
        lastPage: 1,
        to: null,
        from: null,
        total: null,
        controlledPageCount: 1,
    },
    filter: {
        searchString: ""
    },
    isUpdated: false
}

const packagesReducer = (state=initialState, action={}) => {
    const {type, payLoad} = action

    switch(type){
        case Packages_Action_Types.FETCH_PACKAGES_START:
            return {
                ...state, 
                isLoading: true
            }

        case Packages_Action_Types.FETCH_PACKAGES_SUCCESS:
            return {
                ...state,
                packages: payLoad.data,
                isLoading: false,
                pagination: {
                    ...state.pagination,
                    pageNumber: payLoad.current_page,
                    perPage: payLoad.per_page,
                    lastPage: payLoad.last_page,
                    total: payLoad.total,
                    to: payLoad.to,
                    from: payLoad.from,
                    controlledPageCount: payLoad.last_page,
                },
                error: null,
            };
        
        case Packages_Action_Types.FETCH_PACKAGES_LIST_BY_TYPE:
            return {
                ...state,
                packagesListByType: payLoad.data.map((item) => ({
                    ...item,
                    value: item.id,
                    label: item.package_name,
                  })),
            }

        case Packages_Action_Types.FETCH_PACKAGES_FAILED:
            return {
                ...state,
                isLoading: false, 
                error: payLoad
            }

        case Packages_Action_Types.SET_FILTER_SEARCH_STRING:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    searchString: payLoad
                }
            }

        case Packages_Action_Types.SET_PAGE_SIZE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    perPage: payLoad
                }
            }
        
        case Packages_Action_Types.SET_IS_UPDATED:
            return {
                ...state,
                isUpdated: !state.isUpdated
            }

        default:
            return state
        }

    }

export default packagesReducer